import Layout from "../../views/portal/components/Layout.vue";
const routes = [
  {
    path: "/portal",
    component: Layout,
    children: [
      {
        path: "",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "../../views/portal/home/index.vue"
          )
      },
      {
        path: "column/:name",
        component: () =>
          import(
            /* webpackChunkName: "column" */ "../../views/portal/column/index.vue"
          )
      },
      {
        path: "college",
        component: () =>
          import(
            /* webpackChunkName: "college" */ "../../views/portal/college/index.vue"
          )
      },
      {
        path: "download",
        component: () =>
          import(
            /* webpackChunkName: "download" */ "../../views/portal/download/index.vue"
          )
      },
      {
        path: "monitor",
        component: () =>
          import(
            /* webpackChunkName: "monitor" */ "../../views/portal/monitor/index.vue"
          )
      },
      {
        path: "detail/:name",
        component: () =>
          import(
            /* webpackChunkName: "detail" */ "../../views/portal/detail/index.vue"
          )
      }
    ]
  }
];

export default routes;
